import { render, staticRenderFns } from "./header-bendis.vue?vue&type=template&id=8655918c"
import script from "./header-bendis.vue?vue&type=script&lang=js"
export * from "./header-bendis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports